import { render, staticRenderFns } from "./CustomTextareaFour.vue?vue&type=template&id=895d9a0a&"
import script from "./CustomTextareaFour.vue?vue&type=script&lang=js&"
export * from "./CustomTextareaFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports